export const CONTRACT_TERMS = `A+AUTO FLEET — RIDESHARE VEHICLE RENTAL AGREEMENT

1. THE AGREEMENT
This Rental Agreement ("Agreement") is entered into between A+Auto Fleet ("Company", "we", "us") and the individual named in this reservation ("Driver", "you"). By checking the acceptance box, you confirm you have read, understood, and agree to be legally bound by these terms.

2. RIDESHARE & COMMERCIAL USE (PERMITTED)
2.1 This vehicle is expressly approved for use on rideshare and delivery platforms including Uber, Lyft, DoorDash and similar networks, subject to each platform's own vehicle and driver requirements.
2.2 You are responsible for ensuring the vehicle meets the eligibility rules of any platform you drive for (model year, condition, inspection, and insurance endorsements).
2.3 You must maintain an active, in-good-standing driver account on any platform you use during the rental period.

3. ELIGIBILITY & DRIVER REQUIREMENTS
3.1 You must be at least 21 years of age and hold a valid, unexpired driver's licence for the entire rental period.
3.2 You must present a valid government photo ID and licence at collection and pass a standard driving-record check.

4. RENTAL PERIOD & MILEAGE
4.1 Rentals are billed on a weekly basis (7-day cycles) with the equivalent daily rate shown in your reservation.
4.2 UNLIMITED MILEAGE is included — drive as much as you need with no per-mile fees.
4.3 You may return or swap the vehicle at the end of any weekly cycle with 48 hours' notice.

5. PAYMENT
5.1 The rental charge shown is payable at vehicle collection ("Pay at Pickup"). No deposit is required to reserve.
5.2 You are responsible for all fuel/charging, tolls, traffic citations, and parking penalties incurred during the rental period.

6. MAINTENANCE & ROADSIDE
6.1 Routine maintenance (oil, tires, scheduled service) and 24/7 roadside assistance are included at no extra cost.
6.2 You must report any warning light, mechanical issue, or accident to the Company within 24 hours.

7. INSURANCE — DRIVER'S RESPONSIBILITY (MANDATORY)
7.1 The Driver MUST obtain and maintain their own valid third-party liability insurance covering the vehicle for the entire rental period, including any rideshare or commercial-use endorsement required by the platform(s) they drive for.
7.2 Proof of valid third-party insurance must be provided to A+Auto Fleet before the vehicle is released, and coverage must remain active for the full duration of the rental.
7.3 A+Auto Fleet does NOT provide liability insurance on the Driver's behalf. If the Driver fails to obtain or provide their own third-party insurance, the Driver accepts FULL PERSONAL LIABILITY for any and all loss, damage, injury, third-party claims, fines, or costs arising during the rental period.
7.4 The Driver is responsible for any applicable insurance excess/deductible and for all damage caused by negligence, misuse, or breach of this Agreement.

8. USE OF THE VEHICLE
8.1 The vehicle must not be operated while impaired by alcohol, drugs, or any substance, nor used for illegal activity.
8.2 Smoking inside the vehicle is prohibited. A cleaning fee applies for violations.
8.3 Only you and drivers approved in writing by the Company may operate the vehicle.

9. RETURN CONDITION
The vehicle must be returned in the same condition as supplied, save for fair wear and tear.

10. GOVERNING LAW
This Agreement is governed by the laws of the jurisdiction in which the vehicle is collected.

By accepting these terms, you acknowledge this constitutes a binding rental agreement between you and A+Auto Fleet.`;
